module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/negativo_normal.07f83848.svg";